"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_query_1 = require("react-query");
var constants_1 = require("../../../constants");
var utilities_1 = require("../../../utilities");
var react_router_dom_1 = require("react-router-dom");
var services_1 = require("../../../services");
var react_error_boundary_1 = require("react-error-boundary");
var useFetchMerchantsAdmin = function () {
    var _a, _b;
    var _c = (0, react_router_dom_1.useSearchParams)(), searchParams = _c[0], setSearchParams = _c[1];
    var showBoundary = (0, react_error_boundary_1.useErrorBoundary)().showBoundary;
    var company_name = !!searchParams.get('term')
        ? { company_name: searchParams.get('term') }
        : {};
    var queryParamsData = __assign(__assign({}, company_name), { page: Number((_a = searchParams.get('page')) !== null && _a !== void 0 ? _a : 1), per_page: Number((_b = searchParams.get('rowsPerPage')) !== null && _b !== void 0 ? _b : 15) });
    return (0, react_query_1.useQuery)([constants_1.GET_ALL_MERCHANTS, queryParamsData], function () { return services_1.MerchantService.getAllMerchantsForAdmin(queryParamsData); }, {
        staleTime: 1000 * 60 * 30,
        onSuccess: function (data) {
            if (data.data.length === 0) {
                (0, utilities_1.resetPaginationQuery)(searchParams, setSearchParams);
            }
        },
        onError: function (error) {
            (0, utilities_1.handleError)(error);
            showBoundary(error);
        },
    });
};
exports.default = useFetchMerchantsAdmin;
